module.exports = __webpack_public_path__ + "img/icon_map_3_on_001.e1ff7e73.png";